<template>
  <section
    class="layout-pt-lg layout-pb-lg"
    :style="`background-color: var(--c-${vars.backgroundColor}); color: var(--c-${vars.textColor});`"
  >
    <div class="tw-w-full tw-max-w-7xl tw-mx-auto">
  
      <div
        class="relative js-section-slider tw-px-4 md:tw-px-6"
        data-anim="slide-left delay-1"
        data-gap="30"
        data-slider-cols="md-1 sm-1 base-1"
      >
       
        <div class="swiper-wrapper lg:tw-grid lg:tw-grid-cols-3 lg:tw-gap-10">
          <div
            v-for="(branch, index) in branches"
            :key="`contact-branch-${index}`"
            class="swiper-slide tw-flex tw-flex-col tw-items-center tw-text-center tw-space-y-6 tw-mr-6 lg:tw-mr-0"
          >
        
            <div class="tw-w-full">
              <LibraryImage
                :src="branch.photo"
                :w-ratio="720"
                :h-ratio="405"
                image-class="tw-w-full tw-object-cover"
              />
            </div>

        
            <div class="tw-space-y-4 mb-4 tw-w-full">
              <h3 v-if="branch.title" class="tw-text-xl lg:tw-text-2xl tw-font-semibold">
                {{ branch.title }}
              </h3>

              <div class="tw-space-y-3 ">
                <small class="tw-block tw-font-medium tw-tracking-wide uppercase">ADDRESS</small>
                <p :style="`color: var(--c-${vars.textColor}) !important;`">{{ branch.address }}</p>
              </div>

              <div class="tw-space-y-3 mt-4">
                <small class="tw-block  tw-font-medium tw-tracking-wide uppercase">PHONE</small>
                <p :style="`color: var(--c-${vars.textColor}) !important;`">
                  <a :href="`tel:${branch.primary_phone}`" class="n-link">{{ branch.primary_phone }}</a>
                </p>
              </div>

              <div class="tw-space-y-3 mt-4">
                <small class="tw-block tw-font-medium tw-tracking-wide uppercase">EMAIL</small>
                <p :style="`color: var(--c-${vars.textColor}) !important;`">
                  <a :href="`mailto:${branch.primary_email}`" class="n-link">{{ branch.primary_email }}</a>
                </p>
              </div>

              <div class="tw-space-y-3 mt-4">
                <small class="tw-block tw-font-medium tw-tracking-wide uppercase">SOCIALS</small>
                <div class="tw-flex tw-justify-center tw-gap-3">
                 <a  v-if="branch.facebook" :href="branch.facebook" class="n-link tw-group" target="_blank">
                        <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="16.4226" cy="16.1921" r="15.9421" stroke="#BFA87E" stroke-width="0.5"/>
<path d="M17.6237 17.0919H19.123L19.7227 14.6931H17.6237V13.4937C17.6237 12.876 17.6237 12.2943 18.8231 12.2943H19.7227V10.2793C19.5272 10.2535 18.789 10.1953 18.0093 10.1953C16.3811 10.1953 15.2249 11.189 15.2249 13.0139V14.6931H13.4258V17.0919H15.2249V22.1895H17.6237V17.0919Z" fill="#BFA87E"/>
</svg>


                      </a>

                      <!-- Instagram -->
                      <a v-if="branch.instagram" :href="branch.instagram" class="n-link tw-group" target="_blank">
                        <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="16.8054" cy="16.1921" r="15.9421" stroke="#BFA87E" stroke-width="0.5"/>
<path d="M14.2869 10.1953H19.3244C21.2435 10.1953 22.8027 11.7546 22.8027 13.6736V18.7112C22.8027 19.6337 22.4363 20.5184 21.784 21.1707C21.1317 21.823 20.2469 22.1895 19.3244 22.1895H14.2869C12.3678 22.1895 10.8086 20.6302 10.8086 18.7112V13.6736C10.8086 12.7511 11.1751 11.8664 11.8274 11.2141C12.4797 10.5618 13.3644 10.1953 14.2869 10.1953ZM14.167 11.3947C13.5944 11.3947 13.0452 11.6222 12.6403 12.0271C12.2355 12.4319 12.008 12.9811 12.008 13.5537V18.8311C12.008 20.0245 12.9735 20.99 14.167 20.99H19.4444C20.017 20.99 20.5661 20.7626 20.971 20.3577C21.3759 19.9528 21.6033 19.4037 21.6033 18.8311V13.5537C21.6033 12.3603 20.6378 11.3947 19.4444 11.3947H14.167ZM19.9541 12.2943C20.1529 12.2943 20.3436 12.3733 20.4842 12.5139C20.6248 12.6544 20.7038 12.8451 20.7038 13.0439C20.7038 13.2427 20.6248 13.4334 20.4842 13.574C20.3436 13.7146 20.1529 13.7936 19.9541 13.7936C19.7553 13.7936 19.5646 13.7146 19.4241 13.574C19.2835 13.4334 19.2045 13.2427 19.2045 13.0439C19.2045 12.8451 19.2835 12.6544 19.4241 12.5139C19.5646 12.3733 19.7553 12.2943 19.9541 12.2943ZM16.8057 13.1938C17.6009 13.1938 18.3636 13.5098 18.926 14.0721C19.4883 14.6344 19.8042 15.3971 19.8042 16.1924C19.8042 16.9876 19.4883 17.7503 18.926 18.3127C18.3636 18.875 17.6009 19.1909 16.8057 19.1909C16.0104 19.1909 15.2477 18.875 14.6854 18.3127C14.123 17.7503 13.8071 16.9876 13.8071 16.1924C13.8071 15.3971 14.123 14.6344 14.6854 14.0721C15.2477 13.5098 16.0104 13.1938 16.8057 13.1938ZM16.8057 14.3933C16.3285 14.3933 15.8709 14.5828 15.5335 14.9202C15.1961 15.2576 15.0065 15.7152 15.0065 16.1924C15.0065 16.6695 15.1961 17.1272 15.5335 17.4646C15.8709 17.802 16.3285 17.9915 16.8057 17.9915C17.2828 17.9915 17.7404 17.802 18.0778 17.4646C18.4152 17.1272 18.6048 16.6695 18.6048 16.1924C18.6048 15.7152 18.4152 15.2576 18.0778 14.9202C17.7404 14.5828 17.2828 14.3933 16.8057 14.3933Z" fill="#BFA87E"/>
</svg>


                      </a>

                            <!-- Linkedin -->
                      <a v-if="branch.linkedin" :href="branch.linkedin" class="n-link tw-group" target="_blank">
                        <svg width="33" height="33" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="18" cy="18" r="18" stroke="#BFA87E" stroke-width="0.5"/>
<path d="M14.6266 13.3333C14.6265 13.687 14.4858 14.026 14.2356 14.2759C13.9855 14.5259 13.6462 14.6662 13.2926 14.666C12.939 14.6658 12.5999 14.5252 12.35 14.275C12.1001 14.0248 11.9598 13.6856 11.96 13.332C11.9601 12.9784 12.1008 12.6393 12.351 12.3894C12.6011 12.1395 12.9403 11.9992 13.294 11.9993C13.6476 11.9995 13.9867 12.1402 14.2366 12.3903C14.4865 12.6405 14.6268 12.9797 14.6266 13.3333ZM14.6666 15.6533H12V24H14.6666V15.6533ZM18.88 15.6533H16.2266V24H18.8533V19.62C18.8533 17.18 22.0333 16.9533 22.0333 19.62V24H24.6666V18.7133C24.6666 14.6 19.96 14.7533 18.8533 16.7733L18.88 15.6533Z" fill="#BFA87E"/>
</svg>



                      </a>


                      <!-- Youtube -->
                      
                      <a v-if="branch.youtube" :href="branch.youtube" class="n-link tw-group" target="_blank">
                        <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="16.5749" cy="16.1921" r="15.9421" stroke="#BFA87E" stroke-width="0.5"/>
<path d="M16.5752 11.3945C17.0879 11.3945 17.6139 11.4077 18.1236 11.4293L18.7257 11.4581L19.3021 11.4923L19.8418 11.5289L20.3348 11.5672C20.8697 11.6082 21.3731 11.8365 21.7564 12.212C22.1396 12.5874 22.3782 13.086 22.4301 13.62L22.4541 13.8749L22.4991 14.4207C22.5411 14.9862 22.5723 15.6027 22.5723 16.1922C22.5723 16.7817 22.5411 17.3982 22.4991 17.9637L22.4541 18.5095C22.4463 18.597 22.4385 18.6816 22.4301 18.7643C22.3782 19.2984 22.1395 19.7971 21.7562 20.1726C21.3728 20.5481 20.8692 20.7763 20.3342 20.8171L19.8424 20.8549L19.3027 20.8921L18.7257 20.9263L18.1236 20.9551C17.6078 20.9775 17.0915 20.9891 16.5752 20.9898C16.0589 20.9891 15.5426 20.9775 15.0268 20.9551L14.4246 20.9263L13.8483 20.8921L13.3086 20.8549L12.8156 20.8171C12.2807 20.7762 11.7773 20.5479 11.394 20.1724C11.0107 19.7969 10.7722 19.2983 10.7203 18.7643L10.6963 18.5095L10.6513 17.9637C10.6054 17.3743 10.581 16.7834 10.5781 16.1922C10.5781 15.6027 10.6093 14.9862 10.6513 14.4207L10.6963 13.8749C10.7041 13.7874 10.7119 13.7028 10.7203 13.62C10.7722 13.0861 11.0106 12.5876 11.3938 12.2121C11.7769 11.8367 12.2802 11.6083 12.815 11.5672L13.3074 11.5289L13.8471 11.4923L14.424 11.4581L15.0262 11.4293C15.5422 11.4069 16.0587 11.3953 16.5752 11.3945ZM16.5752 12.5939C16.0804 12.5939 15.5713 12.6071 15.0759 12.6275L14.4894 12.6557L13.9263 12.6887L13.3973 12.7247L12.9128 12.7625C12.6581 12.7805 12.4181 12.8882 12.2352 13.0664C12.0523 13.2445 11.9384 13.4817 11.9137 13.7358C11.8435 14.4608 11.7775 15.3634 11.7775 16.1922C11.7775 17.021 11.8435 17.9235 11.9137 18.6486C11.9646 19.1715 12.3796 19.5781 12.9128 19.6219L13.3973 19.6591L13.9263 19.6951L14.4894 19.7287L15.0759 19.7568C15.5713 19.7772 16.0804 19.7904 16.5752 19.7904C17.07 19.7904 17.5791 19.7772 18.0745 19.7568L18.661 19.7287L19.2241 19.6957L19.753 19.6597L20.2376 19.6219C20.4923 19.6038 20.7323 19.4962 20.9152 19.318C21.0981 19.1399 21.212 18.9027 21.2367 18.6486C21.3069 17.9235 21.3729 17.021 21.3729 16.1922C21.3729 15.3634 21.3069 14.4608 21.2367 13.7358C21.212 13.4817 21.0981 13.2445 20.9152 13.0664C20.7323 12.8882 20.4923 12.7805 20.2376 12.7625L19.753 12.7253L19.2241 12.6893L18.661 12.6557L18.0745 12.6275C17.575 12.606 17.0751 12.5948 16.5752 12.5939ZM15.3758 14.7379C15.3757 14.6793 15.39 14.6216 15.4174 14.5697C15.4447 14.5179 15.4843 14.4735 15.5328 14.4405C15.5812 14.4074 15.6369 14.3867 15.6952 14.3801C15.7534 14.3735 15.8124 14.3813 15.8669 14.4027L15.9155 14.4267L18.4343 15.8803C18.4844 15.9093 18.5269 15.9499 18.558 15.9987C18.5891 16.0476 18.6079 16.1032 18.6129 16.1609C18.6179 16.2186 18.6089 16.2766 18.5867 16.3301C18.5645 16.3836 18.5297 16.4309 18.4853 16.4681L18.4343 16.504L15.9155 17.9583C15.8648 17.9877 15.8076 18.0043 15.749 18.0065C15.6904 18.0087 15.6321 17.9966 15.5792 17.9712C15.5264 17.9458 15.4805 17.9078 15.4457 17.8606C15.4109 17.8134 15.3881 17.7585 15.3794 17.7005L15.3758 17.6465V14.7379Z" fill="#BFA87E"/>
</svg>


                      </a>

                      <!-- TikTok -->
                       
                      <a v-if="branch.tiktok" :href="branch.tiktok" class="n-link tw-group" target="_blank">
                        <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="16.1921" cy="16.1921" r="15.9421" stroke="#BFA87E" stroke-width="0.5"/>
<path d="M18.9525 12.4861C18.5426 12.0181 18.3167 11.4171 18.3169 10.7949H16.4638V18.2313C16.4495 18.6337 16.2796 19.0149 15.9899 19.2945C15.7001 19.5742 15.3132 19.7305 14.9105 19.7306C14.0589 19.7306 13.3513 19.0349 13.3513 18.1713C13.3513 17.1398 14.3468 16.3662 15.3723 16.684V14.789C13.3033 14.5131 11.4922 16.1203 11.4922 18.1713C11.4922 20.1683 13.1474 21.5897 14.9045 21.5897C16.7876 21.5897 18.3169 20.0604 18.3169 18.1713V14.3992C19.0683 14.9388 19.9705 15.2283 20.8956 15.2268V13.3737C20.8956 13.3737 19.7681 13.4276 18.9525 12.4861Z" fill="#BFA87E"/>
</svg>

                      </a>
                
                </div>
              </div>

              
            <nuxt-link
             :external="true"
              :key="`takeaction-button-desktop-${index}`"
              :to="branch.link"
              :class="`n-${branch.type} tw-w-auto mt-4`"
            >{{ branch.label }}</nuxt-link>
          
            </div>
          </div>
        </div>

   
      </div>

      <!-- Navigation Buttons for Mobile (brought back) -->
      <div class=" md:mt-10 tw-flex tw-items-center tw-justify-center lg:tw-hidden">
        <button class=" js-prev">
         <svg
        width="61" height="27" viewBox="0 0 61 27"
        fill="none" xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.4697 14.0303C10.1768 13.7374 10.1768 13.2626 10.4697 12.9697L15.2426 8.1967C15.5355 7.90381 16.0104 7.90381 16.3033 8.1967C16.5962 8.48959 16.5962 8.96447 16.3033 9.25736L12.0607 13.5L16.3033 17.7426C16.5962 18.0355 16.5962 18.5104 16.3033 18.8033C16.0104 19.0962 15.5355 19.0962 15.2426 18.8033L10.4697 14.0303ZM61 14.25H11V12.75H61V14.25Z"
          fill="#BFA87E"
        />
        <circle
          cx="13.5" cy="13.5" r="13"
          transform="matrix(-1 0 0 1 27 0)"
          stroke="#BFA87E" stroke-opacity="0.5"
        />
      </svg>
        </button>
        <button class=" js-next">
          <svg
        width="61" height="27" viewBox="0 0 61 27"
        fill="none" xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M50.5303 14.0303C50.8232 13.7374 50.8232 13.2626 50.5303 12.9697L45.7574 8.1967C45.4645 7.90381 44.9896 7.90381 44.6967 8.1967C44.4038 8.48959 44.4038 8.96447 44.6967 9.25736L48.9393 13.5L44.6967 17.7426C44.4038 18.0355 44.4038 18.5104 44.6967 18.8033C44.9896 19.0962 45.4645 19.0962 45.7574 18.8033L50.5303 14.0303ZM0 14.25H50V12.75H0V14.25Z"
          fill="#BFA87E"
        />
        <circle
          cx="47.5" cy="13.5" r="13"
          stroke="#BFA87E" stroke-opacity="0.5"
        />
      </svg>
        </button>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';
import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
// Swiper CSS
import 'swiper/css';
import 'swiper/css/navigation';

Swiper.use([Navigation]);

export default defineNuxtComponent({
  name: 'ContactUs',
  mixins: [ComponentMixin],
  computed: {
    branches() {
      return this.groupedVariables.branches;
    },
   
  },
  mounted() {
    if (window.innerWidth < 1024) {
      new Swiper('.js-section-slider', {
        slidesPerView: 1,
        spaceBetween: 30,
        navigation: {
          nextEl: '.js-next',
          prevEl: '.js-prev',
        },
        breakpoints: {
          640: { slidesPerView: 1 },
          768: { slidesPerView: 1 },
        },
      });
    }
  },
});
</script>

<style scoped>

.scrollbar::-webkit-scrollbar {
  height: 3px;
}
.scrollbar::-webkit-scrollbar-track {
  background-color: #cbdceb;
  border-radius: 40px;
}
.scrollbar::-webkit-scrollbar-thumb {
  background-color: var(--c-primary);
  border-radius: 40px;
}


@media (max-width: 1023px) {
  .js-section-slider {
    overflow: hidden;
  }
}


@media (min-width: 1024px) {
  .swiper-wrapper {
    display: grid !important;
    grid-template-columns: repeat(3, 1fr) !important;
    gap: 2.5rem !important;
  }
  .swiper-slide {
    width: auto !important;
  }
}

/* Slider navigation buttons styling */
.sliderNav {
  cursor: pointer;
  padding: 8px;
  border-radius: 50%;
  border: 1px solid var(--c-textColor);
  transition: background-color 0.3s;
}
.sliderNav:hover {
  background-color: var(--c-primary);
}
.sliderNav i {
  font-size: 16px;
}

</style>
